<template>
    <module-card :nextFunction="unlockResources">
        <p>
            <strong>Most HIV testing is confidential.</strong> If you take an anonymous test (which is tracked by a number, not your name), no one but you will know the result. If you take a confidential test, your test result will be part
            of your medical record, but it is still protected by state and federal privacy laws, which means that your health care provider will only tell YOU the results of these tests, not anyone else.
        </p>
        <p>
            In a perfect world, we can talk to our parents and caregivers about anything. Although we encourage you to identify a trusted adult to talk to about your HIV test result or HIV status, if you really can’t talk to anyone, you
            still need to make your health a priority, which includes protecting yourself from HIV/STIs.
        </p>
        <p>In most states, once you are 13, you can get checked and tested for HIV/STIs without a parent’s involvement.</p>
        <p>
            To find out whether you can get checked and tested for HIV/STIs without a parent’s involvement, go here:
            <external-link href="https://sexetc.org/action-center/sex-in-the-states/" target="_blank">https://sexetc.org/action-center/sex-in-the-states/</external-link>.
        </p>
    </module-card>
</template>

<script>
    import { sync } from 'vuex-pathify';
    import { forEach } from 'lodash';

    export default {
        computed: {
            resources: sync('resources')
        },
        methods: {
            unlockResources() {
                // unlock alcohol and marijuana resources
                forEach(this.resources, (o) => {
                    if (o.category === 'HIV' && o.topic === 'Sex in the States') {
                        o.unlocked = true;
                    }
                });
            }
        }
    };
</script>
